/**
 * EventSource Polyfill Helper
 * Loads the event-source-polyfill and assigns it to window.EventSourcePolyfill
 * Matches the sample app pattern exactly
 */

import EventSource from 'event-source-polyfill';

if (typeof window === 'object') {
  window.EventSourcePolyfill = EventSource;
  if (!window.EventSource) {
    window.EventSource = EventSource;
  }
} else {
  console.error('[Salesforce:Polyfill] Window not available');
}

export default EventSource;